import { useLocation } from 'react-router-dom'
import { Typography } from '@mui/material'

const MainToolbarText = () => {
  const { pathname } = useLocation()
  const getPathNameCn = () => {
    const path = pathname
    let name = ''
    if (/admins\/list/.test(path)) name = '管理员 / 管理员列表'
    if (/admins\/add/.test(path)) name = '管理员 / 添加管理员'
    if (/admins\/modify/.test(path)) name = '管理员 / 修改管理员'
    if (/menu\/list/.test(path)) name = '导航菜单 / 导航菜单列表'
    if (/menu\/add/.test(path)) name = '导航菜单 / 添加导航菜单'
    if (/menu\/modify/.test(path)) name = '导航菜单 / 修改导航菜单'
    if (/movie\/list/.test(path)) name = '电影管理 / 电影列表'
    if (/movie\/add/.test(path)) name = '电影管理 / 添加电影'
    if (/movie\/modify/.test(path)) name = '电影管理 / 修改电影'
    if (/diary\/list/.test(path)) name = '日记管理 / 日记列表'
    if (/diary\/add/.test(path)) name = '日记管理 / 添加日记'
    if (/diary\/modify/.test(path)) name = '日记管理 / 修改日记'
    if (/dailyRun\/list/.test(path)) name = '运动管理 / 日常跑步列表'
    if (/dailyRun\/add/.test(path)) name = '运动管理 / 添加日常跑步'
    if (/dailyRun\/modify/.test(path)) name = '运动管理 / 修改日常跑步'
    if (/marathon\/list/.test(path)) name = '运动管理 / 马拉松列表'
    if (/marathon\/add/.test(path)) name = '运动管理 / 添加马拉松'
    if (/marathon\/modify/.test(path)) name = '运动管理 / 修改马拉松'
    if (/cake\/making\/list/.test(path)) name = '西点管理 / 西点列表'
    if (/cake\/making\/add/.test(path)) name = '西点管理 / 添加西点'
    if (/cake\/making\/modify/.test(path)) name = '西点管理 / 修改西点'
    if (/petrol\/list/.test(path)) name = '油价管理 / 油价列表'
    if (/petrol\/add/.test(path)) name = '油价管理 / 添加油价'
    if (/petrol\/modify/.test(path)) name = '油价管理 / 修改油价'
    return name
  }

  return (
    <div className='flex align-items-start'>
      <Typography variant="h6" noWrap><b style={{ color: '#ffc500' }}>JOEDAR.MANAGE</b></Typography>
      <div style={{ marginLeft: '1em' }}>{getPathNameCn()}</div>
    </div>
  )
}

export default MainToolbarText
